/**
 * Embroidery Form Interceptor
 * 拦截产品表单提交，当选择了embroidery时使用组合添加逻辑
 */

// Global function to clean empty properties from form, especially embroidery-related ones
window.cleanEmptyPropertiesFromForm = function(form) {
  let hasCleanedProperties = false;
  
  console.log('🧹 Starting property cleanup for form:', form.id || 'unnamed');
  
  // Define embroidery-related property patterns
  const embroideryPatterns = [
    'properties[Embroidery Text]',
    'properties[Embroidery Font]', 
    'properties[Embroidery Color]',
    'properties[_Embroidery Color Value]',
    'properties[_embroidery_product_key]',
    // Also catch variations
    'properties[_embroidery',
    'properties[Embroidery'
  ];
  
  // Get all property inputs: both inside the form and externally associated via form attribute
  const formId = form.id;
  const internalInputs = form.querySelectorAll('input[name^="properties["]');
  const externalInputs = formId ? document.querySelectorAll(`input[name^="properties["][form="${formId}"]`) : [];
  
  // Combine all property inputs and remove duplicates (in case some inputs are found in both searches)
  const allInputsArray = [...internalInputs, ...externalInputs];
  const propertyInputs = allInputsArray.filter((input, index, self) => 
    index === self.findIndex(i => i.name === input.name && i.id === input.id)
  );
  
  console.log(`🔍 Found ${propertyInputs.length} property inputs in form (${internalInputs.length} internal + ${externalInputs.length} external)`);
  
  // Debug: log all found inputs
  if (propertyInputs.length > 0) {
    console.log('📋 Property inputs found:');
    propertyInputs.forEach((input, index) => {
      console.log(`  ${index + 1}. ${input.name} = "${input.value}" (${input.form ? 'external' : 'internal'})`);
    });
  }
  
  let removedCount = 0;
  let keptCount = 0;
  
  propertyInputs.forEach(input => {
    const inputName = input.name;
    const value = input.value ? input.value.trim() : '';
    const location = input.form ? 'external' : 'internal';
    
    // Check if this is an embroidery-related property
    const isEmbroideryProperty = embroideryPatterns.some(pattern => 
      inputName === pattern || inputName.includes(pattern.replace('properties[', '').replace(']', ''))
    );
    
    // If the property value is empty, remove the input from the form
    if (!value) {
      console.log(`🗑️ Removing empty property input (${location}):`, inputName, `[id: ${input.id}]`);
      input.remove();
      hasCleanedProperties = true;
      removedCount++;
    } else {
      keptCount++;
      if (isEmbroideryProperty) {
        // Log embroidery properties that have values (for debugging)
        console.log(`✅ Keeping embroidery property with value (${location}):`, inputName, '=', value);
      } else {
        console.log(`📝 Keeping non-embroidery property (${location}):`, inputName, '=', value);
      }
    }
  });
  
  console.log(`📊 Cleanup summary: ${removedCount} removed, ${keptCount} kept`);
  
  // Also check for any other properties that might be set via JavaScript
  // This is for properties that are dynamically added but may be empty
  if (form.dataset && form.dataset.properties) {
    try {
      const properties = JSON.parse(form.dataset.properties);
      const cleanedProperties = {};
      let hasNonEmptyProperties = false;
      
      for (const [key, value] of Object.entries(properties)) {
        if (value && value.toString().trim()) {
          cleanedProperties[key] = value;
          hasNonEmptyProperties = true;
        } else {
          console.log('🗑️ Removing empty property from dataset:', key);
          hasCleanedProperties = true;
        }
      }
      
      if (hasNonEmptyProperties) {
        form.dataset.properties = JSON.stringify(cleanedProperties);
      } else {
        delete form.dataset.properties;
      }
    } catch (e) {
      console.warn('⚠️ Failed to parse form dataset properties:', e);
    }
  }
  
  console.log(`🧹 Property cleanup completed. Cleaned: ${hasCleanedProperties}`);
  return hasCleanedProperties;
};

// 立即执行，不等待DOMContentLoaded
(function() {
  console.log('🎯 Embroidery form interceptor loading...');
  console.log('🎯 Script loaded at:', new Date().toISOString());
  console.log('🎯 Document ready state:', document.readyState);

  // 设置全局标志，便于调试
  window.embroideryFormInterceptorLoaded = true;
  
  function initInterceptor() {
    console.log('🎯 Embroidery form interceptor initialized');
    console.log('🎯 Adding submit event listener to document...');
    console.log('🔍 Checking if addToCartEmbroidery function is available:', typeof window.addToCartEmbroidery);

    // 拦截所有product-form的提交事件 - 使用capture阶段获得更高优先级
    document.addEventListener('submit', async function(event) {
      try {
        const form = event.target;
        
        // 安全检查form属性，防止TypeError
        // 使用getAttribute来避免name="id"元素覆盖form.id的问题
        const formId = form.getAttribute('id') || '';
        const formAction = String(form.action || '');
        
        // 安全的字符串检查函数
        const safeIncludes = (str, searchStr) => {
          try {
            return String(str || '').includes(searchStr);
          } catch (e) {
            return false;
          }
        };
        
        console.log('📝 Form submission detected:', {
          tagName: form.tagName,
          id: formId,
          formIdType: typeof formId,
          formIdViaProperty: form.id,
          formIdViaAttribute: form.getAttribute('id'),
          action: formAction,
          isProductForm: form.matches ? form.matches('form[is="product-form"]') : false,
          hasProductFormId: safeIncludes(formId, 'product-form')
        });
        
        // 检查是否是product-form
        const isProductForm = (form.matches && form.matches('form[is="product-form"]')) || safeIncludes(formId, 'product-form');
        if (!isProductForm) {
          console.log('⚪ Not a product form, ignoring');
          return;
        }
        
        console.log('✅ Product form submission detected');
        
        // Always clean empty properties before any processing
        console.log('🧹 Cleaning empty properties before form processing...');
        const hasCleanedProperties = window.cleanEmptyPropertiesFromForm(form);
        if (hasCleanedProperties) {
          console.log('✅ Successfully cleaned empty properties from form');
        }
        
        // 检查是否选择了embroidery - 支持form内部和外部关联的checkbox
        let embroideryCheckbox = form.querySelector('[data-addon-checkbox-input]:checked');
        let allEmbroideryCheckboxes = form.querySelectorAll('[data-addon-checkbox-input]');

        // 使用正确的选择器：ll-embroidery-checkbox-input
        if (!embroideryCheckbox) {
          embroideryCheckbox = form.querySelector('.ll-embroidery-checkbox-input:checked');
        }
        if (allEmbroideryCheckboxes.length === 0) {
          allEmbroideryCheckboxes = form.querySelectorAll('.ll-embroidery-checkbox-input');
        }

        // 如果form内部没有找到，查找通过form属性关联的外部checkbox
        if (formId && (!embroideryCheckbox || allEmbroideryCheckboxes.length === 0)) {
          console.log('🔍 Form内部未找到刺绣checkbox，查找form外部关联checkbox...');

          if (!embroideryCheckbox) {
            embroideryCheckbox = document.querySelector(`[data-addon-checkbox-input][form="${formId}"]:checked`) ||
                                document.querySelector(`.ll-embroidery-checkbox-input[form="${formId}"]:checked`);
          }

          if (allEmbroideryCheckboxes.length === 0) {
            allEmbroideryCheckboxes = document.querySelectorAll(`[data-addon-checkbox-input][form="${formId}"], .ll-embroidery-checkbox-input[form="${formId}"]`);
          }
        }
        
        // 额外检查：也查找可能的embroidery相关checkbox
        const embroideryCheckboxes = form.querySelectorAll('input[type="checkbox"]');
        const embroideryRelatedCheckboxes = Array.from(embroideryCheckboxes).filter(cb => {
          const id = cb.id?.toLowerCase() || '';
          const name = cb.name?.toLowerCase() || '';
          const className = cb.className?.toLowerCase() || '';
          return id.includes('embroidery') || name.includes('embroidery') || className.includes('embroidery');
        });
        
        console.log('🎨 Embroidery checkbox status (enhanced):', {
          formId: formId,
          totalAddonCheckboxes: allEmbroideryCheckboxes.length,
          checkedAddonCheckbox: !!embroideryCheckbox,
          embroideryCheckboxDetails: embroideryCheckbox ? {
            checked: embroideryCheckbox.checked,
            id: embroideryCheckbox.id,
            value: embroideryCheckbox.value,
            form: embroideryCheckbox.form?.id,
            formAttribute: embroideryCheckbox.getAttribute('form')
          } : null,
          addonCheckboxes: Array.from(allEmbroideryCheckboxes).map(cb => ({
            checked: cb.checked,
            id: cb.id,
            value: cb.value,
            form: cb.form?.id,
            formAttribute: cb.getAttribute('form'),
            dataset: cb.dataset
          })),
          embroideryRelatedCheckboxes: embroideryRelatedCheckboxes.length,
          checkedEmbroideryRelated: embroideryRelatedCheckboxes.filter(cb => cb.checked).map(cb => ({
            checked: cb.checked,
            id: cb.id,
            name: cb.name,
            value: cb.value,
            form: cb.form?.id,
            formAttribute: cb.getAttribute('form')
          }))
        });
        
        // 检查是否有任何embroidery相关属性 - 修复：支持form外部元素
        let hasEmbroideryProps = form.querySelector('input[name*="embroidery"], input[name*="Embroidery"]');
        let embroideryText = form.querySelector('input[name="properties[Embroidery Text]"]')?.value?.trim();
        let embroideryFont = form.querySelector('input[name="properties[Embroidery Font]"]')?.value;
        let embroideryColor = form.querySelector('input[name="properties[Embroidery Color]"]')?.value;
        
        // 如果form内部没有找到，查找通过form属性关联的外部元素
        if (formId && (!hasEmbroideryProps || !embroideryText)) {
          console.log('🔍 Form内部未找到刺绣元素，查找form外部关联元素...');
          
          if (!hasEmbroideryProps) {
            hasEmbroideryProps = document.querySelector(`input[name*="embroidery"][form="${formId}"], input[name*="Embroidery"][form="${formId}"]`);
          }
          
          if (!embroideryText) {
            embroideryText = document.querySelector(`input[name="properties[Embroidery Text]"][form="${formId}"]`)?.value?.trim();
          }
          
          if (!embroideryFont) {
            embroideryFont = document.querySelector(`input[name="properties[Embroidery Font]"][form="${formId}"]`)?.value;
          }
          
          if (!embroideryColor) {
            embroideryColor = document.querySelector(`input[name="properties[Embroidery Color]"][form="${formId}"]`)?.value;
          }
          
          console.log('🔍 外部关联元素检查结果:', {
            hasEmbroideryProps: !!hasEmbroideryProps,
            embroideryText: embroideryText,
            embroideryFont: embroideryFont,
            embroideryColor: embroideryColor
          });
        }
        
        console.log('🎨 Embroidery properties check:', {
          hasEmbroideryProps: !!hasEmbroideryProps,
          embroideryText: embroideryText,
          embroideryFont: embroideryFont,
          embroideryColor: embroideryColor,
          allEmbroideryInputs: Array.from(form.querySelectorAll('input[name*="embroidery"], input[name*="Embroidery"]')).map(input => ({
            name: input.name,
            value: input.value,
            disabled: input.disabled
          }))
        });
        
        // 检查是否应该使用刺绣逻辑
        const shouldUseEmbroideryLogic = embroideryCheckbox || (embroideryText && embroideryText.trim() !== '');

        console.log('🎯 Embroidery logic decision:', {
          embroideryCheckbox: !!embroideryCheckbox,
          embroideryText: embroideryText,
          embroideryFont: embroideryFont,
          embroideryColor: embroideryColor,
          shouldUseEmbroideryLogic: shouldUseEmbroideryLogic,
          decision: shouldUseEmbroideryLogic ? 'INTERCEPT' : 'ALLOW_NORMAL_FLOW'
        });

        if (!shouldUseEmbroideryLogic) {
          console.log('⚪ No embroidery selected (no checkbox checked and no embroidery text), allowing normal flow');
          return; // 没有选择embroidery，继续正常流程
        }

        if (!embroideryCheckbox && embroideryText) {
          console.log('🔄 No checkbox checked but embroidery text found, will use embroidery logic');
        } else if (embroideryCheckbox) {
          console.log('✅ Embroidery checkbox checked, will use embroidery logic');
        }
        
        console.log('🚀 Embroidery selected, intercepting form submission');
        console.log('🔒 Preventing default form submission...');
        
        // 阻止默认的表单提交
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        console.log('✅ Default submission prevented successfully');
        
        // 验证表单
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        
        // 检查embroidery信息是否完整 - 使用前面已经获取的值
        console.log('🎨 Embroidery form data validation:', {
          text: embroideryText,
          font: embroideryFont,
          color: embroideryColor,
          textElement: !!form.querySelector('input[name="properties[Embroidery Text]"]'),
          fontElement: !!form.querySelector('input[name="properties[Embroidery Font]"]'),
          colorElement: !!form.querySelector('input[name="properties[Embroidery Color]"]'),
          textDisabled: form.querySelector('input[name="properties[Embroidery Text]"]')?.disabled,
          fontDisabled: form.querySelector('input[name="properties[Embroidery Font]"]')?.disabled,
          colorDisabled: form.querySelector('input[name="properties[Embroidery Color]"]')?.disabled
        });
        
        if (!embroideryText || !embroideryFont || !embroideryColor) {
          console.error('❌ Incomplete embroidery information:', {
            missingText: !embroideryText,
            missingFont: !embroideryFont,
            missingColor: !embroideryColor
          });
          console.error('Please complete all embroidery information before adding to cart.');
          return;
        }
        
        // 显示加载状态
        const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
        submitButtons.forEach((submitButton) => {
          submitButton.setAttribute("disabled", "disabled");
          submitButton.setAttribute("aria-busy", "true");
          submitButton.classList.add("loading");
        });
        
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
        
        try {
          console.log('💡 Using combined embroidery logic...');
          
          // 使用新的组合添加逻辑
          // 等待 addToCartEmbroidery 函数可用
          let attempts = 0;
          const maxAttempts = 50; // 最多等待5秒

          while (!window.addToCartEmbroidery && attempts < maxAttempts) {
            console.log(`⏳ Waiting for addToCartEmbroidery function... (attempt ${attempts + 1})`);
            await new Promise(resolve => setTimeout(resolve, 100));
            attempts++;
          }

          if (window.addToCartEmbroidery) {
            console.log('🎯 Calling window.addToCartEmbroidery...');
            const response = await window.addToCartEmbroidery(form);

            console.log('📦 addToCartEmbroidery response:', response);
            
            if (response && response.ok) {
              const responseJson = await response.json();
              console.log('✅ Response JSON:', responseJson);
              
              // 模拟原有的成功逻辑
              if (window.themeVariables?.settings?.cartType === "page" || window.themeVariables?.settings?.pageType === "cart") {
                window.location.href = `${Shopify.routes.root}cart`;
                return;
              }
              
              // 获取购物车内容并触发相关事件
              const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
              cartContent["sections"] = responseJson["sections"];
              
              form.dispatchEvent(new CustomEvent("variant:add", {
                bubbles: true,
                detail: {
                  items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
                  cart: cartContent,
                  onSuccessDo: form.querySelector('[name="on_success"]')?.value
                }
              }));
              
              document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                  baseEvent: "variant:add",
                  onSuccessDo: form.querySelector('[name="on_success"]')?.value,
                  cart: cartContent
                }
              }));
              
              console.log('Successfully added products using combined embroidery logic');
            } else {
              throw new Error('Failed to add products to cart');
            }
          } else {
            console.error('❌ window.addToCartEmbroidery is not available after waiting');
            console.error('🔍 Available window properties containing "embroidery":',
              Object.keys(window).filter(key => key.toLowerCase().includes('embroidery')));
            console.error('🔍 window.addToCartEmbroidery type:', typeof window.addToCartEmbroidery);
            throw new Error('Embroidery add function not available');
          }
          
        } catch (error) {
          console.error('Error in embroidery form submission:', error);
          
          // 触发错误事件
          form.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: error.message || 'Failed to add products to cart'
            }
          }));
          
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          
          // 记录错误消息
          console.error(`Error adding products to cart: ${error.message}`);
          
        } finally {
          // 恢复提交按钮状态
          submitButtons.forEach((submitButton) => {
            submitButton.removeAttribute("disabled");
            submitButton.removeAttribute("aria-busy");
            submitButton.classList.remove("loading");
          });
          
          document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        }
        
      } catch (error) {
        console.error('❌ Error in form submission detection:', error);
        // 如果检测出错，不拦截表单提交，让默认行为继续
        return;
      }
    }, true); // 使用capture阶段来确保我们在其他事件处理器之前运行
  }
  
  // 如果DOM已经加载完成，立即初始化；否则等待DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInterceptor);
  } else {
    initInterceptor();
  }
  
})();